import { useEffect } from 'react';
import { overlay } from 'overlay-kit';
import '@/shared/plan/events.quiz-trial-discount';
import { trackEvent } from '@zep/logger/tracking';
import { isInLtiContext } from '@/shared/lti';
import { type TrialEndDiscountState } from '@/shared/plan/trialEndDiscount';
import { useTrialEndDiscount } from '@/shared/plan/useTrialEndDiscount';
import { TrialEndDiscountModal } from './TrialEndDiscountModal';
export function openTrialEndDiscountModal(discount: TrialEndDiscountState, trigger: 'auto' | 'banner') {
  if (isInLtiContext()) return;
  trackEvent('quiz_trial_discount_modal_view', {
    remaining_hours: Math.floor(discount.remainingMs / (60 * 60 * 1000)),
    trigger,
    phase: 'post-expiry'
  });
  overlay.open(({
    unmount
  }) => <LiveTrialEndDiscountModal onClose={unmount} />);
}
function LiveTrialEndDiscountModal({
  onClose
}: {
  onClose: () => void;
}) {
  const discount = useTrialEndDiscount();
  const isVisible = discount.status === 'active' || discount.status === 'urgent';
  useEffect(() => {
    if (!isVisible) onClose();
  }, [isVisible, onClose]);
  return isVisible ? <TrialEndDiscountModal discount={discount} onClose={onClose} data-sentry-element="TrialEndDiscountModal" data-sentry-component="LiveTrialEndDiscountModal" data-sentry-source-file="openTrialEndDiscountModal.tsx" /> : null;
}